<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Create Account</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="item.email"
                            label="Email Address"
                            rules="required|email"
                          />
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="item.firstName"
                            label="First Name"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="item.lastName"
                            label="Last Name"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="item.company"
                            label="Company"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="item.jobTitle"
                            label="Job Title"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="item.phone"
                            label="Phone"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-12-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Consumer Type"
                            rules="required"
                          >
                            <b-field
                              label="Consumer Type"
                              class="is-block"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-checkbox
                                v-model="item.role"
                                native-value="buyer"
                              >
                                Buyer
                              </b-checkbox>
                              <b-checkbox
                                v-model="item.role"
                                native-value="seller"
                              >
                                Seller
                              </b-checkbox>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Password"
                            rules="required|confirmed:confirmpassword|min:8"
                          >
                            <b-field
                              label="Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="item.password"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Confirm Password"
                            rules="required"
                            vid="confirmpassword"
                          >
                            <b-field
                              label="Confirm Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="confirmpassword"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Create Account</button
                        ><br />
                      </div>
                      <router-link :to="{ name: 'Login' }" class="is-size-6"
                        >Already Registered?</router-link
                      >
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import AuthApi from '@/api/auth'
export default {
  name: 'Register',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Create Account'
  },
  data() {
    return {
      loading: false,
      item: {
        role: []
      },
      confirmpassword: ''
    }
  },
  computed: {},
  mounted() {},
  methods: {
    submit() {
      this.loading = true
      AuthApi.register(this.item)
        .then(() => {
          this.$buefy.toast.open({
            message: `You've registered successfully! You'll receive an email in your inbox to verify your email address.`,
            position: 'is-top',
            type: 'is-success'
          })
          this.$router.push({ name: 'Login', query: { registered: true } })
          this.loading = false
        })
        .catch(err => {
          let message = 'Error registering user.'
          if (err && err.data && err.data.err) {
            switch (err.data.err) {
              case 'E_MISSING_PARAMS':
                message = 'Some fields are missing'
                break
              case 'E_USER_NOT_VERIFIED':
                message =
                  "You're already registered, you need to verify your account. Check your inbox for the verification email."
                break
              case 'E_USER_EXISTS':
                message = "You're already registered."
                break
            }
          }

          this.$buefy.toast.open({
            message: message,
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
